import { put, select, takeLatest } from 'redux-saga/effects'
import { StateCustomDataConstants } from '../store/nemsisCustomData.constants'
import { ISingleStateCustomElement, IStateCustomDataDisplayState } from '../store/nemsisCustomData.types'
import { setCustomDisplayData } from '../store/nemsisCustomData.actions'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { getStateCustomDisplayDataSelector } from '../selectors/stateCustomDisplayData.selector'

export function* setCustomStateDisplayValue() {
  try {
    const customDisplayData: IStateCustomDataDisplayState = yield select(getStateCustomDisplayDataSelector)
    const {
      stateCustomElements,
      groupingSequence,
      customElementId,
      customElementValue,
      customElementPNNVValue,
      key,
      groupKey,
    } = customDisplayData
    const stateCustomElementsCopy = [...stateCustomElements]
    const updatedStateCustomElements = stateCustomElementsCopy.map((stateElements: ISingleStateCustomElement) => {
      return {
        ...stateElements,
        groups: stateElements.groups.map((elementGroup) => {
          if (elementGroup.groupKey !== groupKey || elementGroup.groupingSequence !== groupingSequence) {
            return elementGroup
          } else {
            return {
              ...elementGroup,
              customElements: elementGroup.customElements.map((customElement) => {
                const isMatch =
                  customElement.id === customElementId && (!customElement.key || customElement.key === key)
                if (isMatch) {
                  return {
                    ...customElement,
                    results: customElementValue ?? [],
                    resultsPNNV: customElementPNNVValue ?? null,
                  }
                } else {
                  return customElement
                }
              }),
            }
          }
        }),
      }
    })
    yield put(setCustomDisplayData(updatedStateCustomElements))
  } catch (e) {
    yield put(throwPcrException(`setCustomStateDisplayValueSaga() error: ${e}`))
  }
}

export function* setCustomStateDisplayValueSaga() {
  yield takeLatest(
    [
      StateCustomDataConstants.SET_STATE_CUSTOM_ELEMENT_VALUE,
      StateCustomDataConstants.SET_STATE_CUSTOM_ELEMENT_PNNV_VALUE,
    ],
    performWithMutexHOG,
    setCustomStateDisplayValue
  )
}
